import { FilterType } from '@/types/additionalFilters'
import { RecCardType } from '@/types/card'
import { defaultGroupedBy, defaultSortedBy, groupByModes } from '@/utils/constants'

export type CardListType = {
  cardviews: RecCardType[]
  header: string
  href?: string
  more?: string
  tag: string
  url?: string
}

export type CardListsStateType = {
  cardLists: CardListType[]
  filters: FilterType[]
  groupedBy: (typeof groupByModes)[number]['key']
  initCardLists: CardListType[]
  loading: boolean
  moreLists?: string
  persist: boolean
  sortedBy: string
  updatedAt: number
}

export const initialCardListsState: CardListsStateType = {
  cardLists: [],
  filters: [],
  groupedBy: defaultGroupedBy,
  initCardLists: [],
  loading: false,
  persist: false,
  sortedBy: defaultSortedBy,
  updatedAt: 0,
}
